import { GraphQLError } from 'graphql/index';

interface ExpectedGQLErrorPattern {
  message: RegExp;
  /** GraphQL field path / operation name, e.g. `contactsSignIn`. */
  path: string;
}

const EXPECTED_GQL_ERROR_PATTERNS: ExpectedGQLErrorPattern[] = [
  // Duplicate invoice number — the user is told by the error notification and fixes the number.
  {
    message: /We already have the invoice with this number from you/i,
    path: 'incomingInvoicesCreate',
  },
  {
    message: /We already have the invoice with this number from you/i,
    path: 'incomingInvoicesUpdate',
  },
  // Login attempt with a wrong password — UI already shows its own message.
  {
    message: /Account not found/i,
    path: 'contactsSignIn',
  },
  {
    message: /Invalid login data/i,
    path: 'contactsSignIn',
  },
  // Offer validation errors — UI already shows its own message.
  {
    message: /Validation Error/i,
    path: 'gshOffersApply',
  },
  {
    message: /Validation Error/i,
    path: 'gshOffersCounteroffer',
  },
  {
    message: /Offer not found/i,
    path: 'gshJobOffer',
  },
  {
    message: /Gst in: can't be blank/i,
    path: 'providersUpdate',
  },
  {
    message: /Can't find an Account with this email/i,
    path: 'contactsInitResetPassword',
  },
  {
    message: /Offer not found/i,
    path: 'gshOffersReject',
  },
  {
    message: /Offer not found/i,
    path: 'gshOffersCounteroffer',
  },
  {
    message: /Offer not found/i,
    path: 'gshOffersApply',
  },
];

export const isExpectedGQLError = (params: {
  gqlError: Pick<GraphQLError, 'message' | 'path'>;
  operationName?: string;
}): boolean => {
  const { gqlError, operationName } = params;
  const pathCandidates = [gqlError.path?.[0], operationName].filter(
    (value): value is string => typeof value === 'string',
  );

  return EXPECTED_GQL_ERROR_PATTERNS.some(
    (pattern) => pattern.message.test(gqlError.message) && pathCandidates.includes(pattern.path),
  );
};
